import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from 'antd';
import dayjs from 'dayjs';

import { TableWithForm } from 'components';

import { useGetHeaders, useUserRole } from 'hooks';

import { DownloadCSVButton } from './DownloadCSVButton';
import { columns, fields, handleOfferMatchesTableChange } from './offerMatchesHelpers';

export const OfferMatches = () => {
  const [url, setUrl] = useState('');

  const headers = useGetHeaders();
  const { offerId } = useParams();
  const { isAdmin } = useUserRole();

  return (
    <Layout className='h-[700px]'>

      <TableWithForm
        horizontalScroll
        id='offer-matches-table'
        size='small'
        columns={columns}
        titleExtraNode={<DownloadCSVButton url={url} />}
        formInitialValues={{ submittedDates: [dayjs().subtract(30, 'day'), dayjs().endOf('day')] }}
        defaultTableParams={{ current: 1, pageSize: 20 }}
        onTableChange={handleOfferMatchesTableChange(headers, setUrl, offerId)}
        // form
        fields={fields(isAdmin)}
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
      />
    </Layout>
  );
};
